import { __assign } from "tslib";
import React from 'react';
import { Avatar } from '@hose/eui';
import { getDisplayName, getStaffShowByConfig } from "./utilFn";
import { getContentByLocale } from '@ekuaibao/lib/lib/i18n-helpers';
import { NameCell } from './name-cell';
export var getTagLabel = function (item, showAvatar, avatarOptions) {
    if (avatarOptions === void 0) { avatarOptions = {
        style: {
            marginRight: 4,
            width: 16,
            height: 16,
            lineHeight: 0,
            marginBottom: 1,
            border: '1px solid var(--eui-static-white)',
            boxSizing: 'content-box'
        }
    }; }
    var staffShowName = getStaffShowByConfig(item);
    var status = item.active === false ? "(" + i18n.get('已停用') + ")" : "";
    var name = "" + staffShowName + status;
    var showA = showAvatar && item.hasOwnProperty('avatar');
    var avatarSrc = (item === null || item === void 0 ? void 0 : item.avatar) || null;
    if (window.isInWeComISV) {
        var _type = void 0;
        if (item.userId) {
            _type = 'user';
        }
        else if (item.type === 'department') {
            _type = 'department';
        }
        else if (item.dataType) {
            _type = item.dataType === 'department-member' ? 'user' : ['department', 'organization.Department'].includes(item.dataType) ? 'department' : _type;
        }
        var name_1 = React.createElement(React.Fragment, null,
            staffShowName,
            status);
        return React.createElement(React.Fragment, null,
            showA && React.createElement(Avatar, __assign({ size: "small", shape: "circle", style: { marginRight: 4 }, src: avatarSrc }, avatarOptions)),
            _type
                ? React.createElement(NameCell, { type: _type, id: item.id, name: name_1 })
                : name_1);
    }
    return (React.createElement(React.Fragment, null,
        showA && React.createElement(Avatar, __assign({ size: "small", shape: "circle", style: { marginRight: 4 }, src: avatarSrc }, avatarOptions)),
        item.label ? item.label : name));
};
var getStaffShow = function (staff) {
    var staffShowName = getStaffShowByConfig(staff);
    var status = '';
    if (staff.authState === false && !staff.external) {
        status = "" + i18n.get('（') + i18n.get('已停用') + i18n.get('）');
    }
    if (staff.active === false) {
        status = "" + i18n.get('（') + i18n.get('已离职') + i18n.get('）');
    }
    return "" + staffShowName + status;
};
var getDimensionShow = function (dimension) {
    var name = getDisplayName(dimension);
    return !!(dimension === null || dimension === void 0 ? void 0 : dimension.code) ? "" + name + i18n.get('（') + dimension.code + i18n.get('）') : name;
};
export var getShowString = function (item, type) {
    var actionMap = {
        staff: getStaffShow,
        role: getDimensionShow,
        department: getDimensionShow
    };
    return actionMap[type](item);
};
export var getItemLabel = function (item) {
    var action = getDimensionShow;
    if (item.hasOwnProperty('avatar')) {
        action = getStaffShow;
    }
    return action(item);
};
export var getDepartmentShowName = function (department) {
    var _a;
    return (_a = department === null || department === void 0 ? void 0 : department.name) !== null && _a !== void 0 ? _a : '';
};
export var getNameByCurrentLocale = function (obj) {
    return getContentByLocale(obj, 'name');
};
export var realName = function (_a) {
    var name = _a.name, enName = _a.enName;
    return (i18n.currentLocale === 'en-US' && enName) ? enName : i18n.get(name);
};
export var realTitle = function (_a) {
    var title = _a.title, enTitle = _a.enTitle;
    return (i18n.currentLocale === 'en-US' && enTitle) ? enTitle : i18n.get(title);
};
export var realDescribe = function (_a) {
    var describe = _a.describe, enDescribe = _a.enDescribe;
    return (i18n.currentLocale === 'en-US' && enDescribe) ? enDescribe : i18n.get(describe);
};
